<template>
  <DragPanel
    :title="getTitle()"
    :closePanel="closePanel"
    ref="panel"
    v-show="isVisible">
    <div class="anchor-form-box">
      <el-form
        :model="anchorForm"
        :rules="rules"
        ref="anchorForm"
        class="public-form-primary"
        label-width="100px">
        <el-form-item
          label="锚点名称："
          prop="name">
          <el-input
            size="small"
            class="input-primary"
            :maxlength="30"
            v-model="anchorForm.name"
            placeholder="请输入锚点名称"
            @blur="updateCurrAnchor" />
        </el-form-item>
        <el-form-item
          label="显示形式："
          prop="anchorPointDisplayForm">
          <div class="radio-group-box">
            <el-radio-group
              class="radio-primary"
              v-model="anchorForm.anchorPointDisplayForm"
              @change="handleDispalyFormChange">
              <el-radio :label="0">普通锚点</el-radio>
              <el-radio :label="1">闪烁锚点</el-radio>
            </el-radio-group>
          </div>
        </el-form-item>
        <el-form-item
          label="所属组："
          prop="groupId">
          <div class="grid-item-box">
            <el-select
              class="primary-select left-item-box"
              size="small"
              v-model="anchorForm.groupId"
              :popper-append-to-body="false"
              placeholder="请选择所属组"
              @change="updateCurrAnchor()">
              <el-option
                v-for="(item, index) in groupList"
                :key="index"
                :label="item.groupName"
                :value="item.groupId" />
            </el-select>
            <el-button
              type="primary"
              class="normal-btn normal-ang-btn"
              size="small"
              icon="el-icon-plus"
              @click="openAddAnchorGroupDialog">
              添加分组
            </el-button>
          </div>
        </el-form-item>
        <el-form-item
          label="锚点类型："
          prop="anchorPointTypeId">
          <div class="grid-item-box">
            <el-select
              class="primary-select left-item-box"
              size="small"
              v-model="anchorForm.anchorPointTypeId"
              :popper-append-to-body="false"
              @focus="initAnchorTypeList()">
              <el-option
                v-for="(item, index) in anchorTypeList"
                :key="index"
                :label="item.typeName"
                :value="item.typeId" />
            </el-select>
            <el-button
              type="primary"
              class="normal-btn normal-ang-btn"
              size="small"
              icon="el-icon-plus"
              @click="openAddAnchorTypeDialog">
              新建类型
            </el-button>
          </div>
        </el-form-item>
        <el-form-item
          label="锚点图标："
          prop="anchorIcon"
          v-if="anchorForm.anchorPointDisplayForm === 0">
          <div class="symbol-grid-icon-box">
            <el-select
              class="primary-select"
              size="small"
              v-model="anchorForm.useSystemIcon"
              :popper-append-to-body="false"
              @change="handleUseSystemIconChange">
              <el-option
                label="系统图标"
                :value="true" />
              <el-option
                label="自定义图标"
                :value="false" />
            </el-select>
            <el-dropdown
              trigger="click"
              class="right-item-box"
              :class="anchorIcon ? '' : 'activeSelect'"
              @visible-change="handleVisibleChange">
              <div class="anchor-symbol-icon-box">
                <div class="img-info-box">
                  <div
                    class="img-box"
                    :style="`background-image:url(${JSON.stringify(
                      currAnchorIcon
                    )})`" />
                  <div
                    class="text-overflow"
                    :title="currAnchorName">
                    {{ currAnchorName }}
                  </div>
                </div>
                <div
                  class="arrow-icon-box"
                  :class="anchorIcon ? '' : 'activeArrow'">
                  <i class="el-icon-arrow-down el-icon--right" />
                </div>
              </div>
              <el-dropdown-menu
                slot="dropdown"
                class="dropdown-primary"
                :append-to-body="false">
                <el-dropdown-item
                  class="system-icon-box"
                  v-if="anchorForm.useSystemIcon">
                  <div
                    class="img-box"
                    v-for="(item, index) in systemIconList"
                    :key="index"
                    @click="handleIconClick(item)">
                    <img :src="item.imgSrc" />
                  </div>
                </el-dropdown-item>
                <el-dropdown-item
                  class="custom-icon-box"
                  v-else>
                  <div class="img-list-box">
                    <div
                      v-if="!customIconList.length"
                      class="img-empty-box">
                      <span>暂无图标，点击</span>
                      <span class="bold-text-box">上传按钮</span>
                      <span>上传图标</span>
                    </div>
                    <div
                      :class="`img-item-box ${
                        isDelIconEnable ? 'is-delete-enable' : ''
                      }`"
                      v-for="item in customIconList"
                      :key="item.iconId"
                      @click="handleIconClick(item)"
                      :style="`background-image:url(${JSON.stringify(
                        item.imgSrc
                      )})`">
                      <div
                        v-if="isDelIconEnable"
                        class="delete-icon-box"
                        @click.stop="deleteCustomIcon(item)">
                        <i class="el-icon-close" />
                      </div>
                    </div>
                    <div class="img-action-box">
                      <el-button
                        class="normal-ang-btn gr8 hollowOut-btn"
                        size="small"
                        @click.stop="enableDeleteIcon">
                        删除
                      </el-button>
                      <el-upload
                        ref="upload"
                        :action="customIconAction"
                        :headers="headers"
                        :data="uploadParams"
                        accept=".jpg,.png"
                        :show-file-list="false"
                        :before-upload="handleCustomIconBeforeUpload"
                        :on-change="handleCustomIconChange"
                        :on-success="handleCustomIconSuccess"
                        :on-error="onCustomIconError"
                        :auto-upload="false"
                        @click.native="e => e.stopPropagation()">
                        <div class="primary-btn primary-ang-btn sumbit-btn">上传</div>
                      </el-upload>
                    </div>
                  </div>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </el-form-item>
        <el-form-item>
          <template slot="label">
            <div class="form-label-box">锚点描述：</div>
          </template>
          <el-input
            class="input-primary"
            v-model="anchorForm.description"
            autocomplete="off"
            placeholder="请输入锚点描述"
            type="textarea"
            maxlength="100"
            rows="4"
            show-word-limit />
        </el-form-item>
        <el-form-item>
          <template slot="label">
            <div class="label-with-tip-box">
              <div class="dialog-label">可视距离</div>
              <el-tooltip
                :effect="$theme.tooltipKey()"
                placement="top-start"
                popper-class="common-panel-tooltip-box">
                <div slot="content">
                  设定锚点的可视距离阈值，若实际距离超出该预设值，则锚点将不再显示，若不设置，则锚点始终可见
                </div>
                <div class="icon-box">
                  <icon-svg icon-class="ic-jieshishuoming" />
                </div>
              </el-tooltip>
              <div>：</div>
            </div>
          </template>
          <div class="grid-item-box special-grid-item">
            <el-input-number
              class="left-item-box"
              size="small"
              :controls="false"
              v-model="anchorForm.visibleDistance"
              @blur="updateCurrAnchor" />
            <el-select
              class="primary-select"
              size="small"
              v-model="anchorForm.visibleDistanceUnit"
              :popper-append-to-body="false"
              @change="updateCurrAnchor">
              <el-option
                label="km"
                value="Kilometer" />
              <el-option
                label="m"
                value="Meter" />
            </el-select>
            <div />
          </div>
        </el-form-item>
        <el-form-item>
          <template slot="label">
            <div class="label-with-tip-box">
              <div class="dialog-label">近大远小</div>
              <el-tooltip
                :effect="$theme.tooltipKey()"
                placement="top-start"
                popper-class="common-panel-tooltip-box">
                <div slot="content">
                  设置锚点超出设置的距离阀值后会近大远小，拉远视角看效果
                </div>
                <div class="icon-box">
                  <icon-svg icon-class="ic-jieshishuoming" />
                </div>
              </el-tooltip>
              <div>：</div>
            </div>
          </template>
          <div class="grid-item-box special-grid-item">
            <el-input-number
              class="left-item-box"
              size="small"
              :controls="false"
              v-model="anchorForm.scalingThreshold"
              @blur="updateCurrAnchor" />
            <el-select
              class="primary-select"
              size="small"
              v-model="anchorForm.scalingThresholdUnit"
              :popper-append-to-body="false"
              @change="updateCurrAnchor">
              <el-option
                label="km"
                value="Kilometer" />
              <el-option
                label="m"
                value="Meter" />
            </el-select>
          </div>
        </el-form-item>
        <el-form-item
          label="附件："
          class="last-form-item">
          <el-button
            v-show="attachmentList.length < 5"
            size="small"
            class="upload-btn normal-btn normal-ang-btn"
            id="anchor-attachment-upload"
            key="uploadFile"
            @click="uploadAttachment">
            <icon-svg
              icon-class="icon-upload"
              size="14" />
            点击上传
          </el-button>
          <el-button
            v-if="attachmentList.length >= 5"
            size="small"
            class="normal-btn normal-ang-btn"
            :disabled="true">
            <icon-svg
              icon-class="icon-upload"
              size="14" />
            点击上传
          </el-button>
        </el-form-item>
        <div class="attachment-file-list-box">
          <div
            v-for="(item, index) in attachmentList"
            :key="index"
            class="file-item-box">
            <div class="file-info-box">
              <div class="file-name-box">
                <div class="icon-box">
                  <img :src="getFileTypeIcon(item.fileName)" />
                </div>
                <div
                  :class="getAttachmentNameClassName(item)"
                  :tittle="item.fileName">
                  {{ `${item.fileName}(${getFileSize(item.fileSize)})` }}
                </div>
              </div>
              <div
                class="file-action-btn-box"
                v-if="item.fileStatus === 'uploadSuccess'">
                <el-button
                  v-if="isViewAttachmentBtnVisible(item)"
                  type="text"
                  size="small"
                  title="查看"
                  @click.stop="viewAttachment(item)">
                  <icon-svg icon-class="icon-chakanxiangqing" />
                </el-button>
                <el-button
                  type="text"
                  size="small"
                  title="下载"
                  @click.stop="downloadAttachment(item)">
                  <icon-svg icon-class="icon-xiazai" />
                </el-button>
                <el-button
                  type="text"
                  size="small"
                  title="删除"
                  @click.stop="deleteAttachment(item)">
                  <icon-svg icon-class="icon-shanchushikou" />
                </el-button>
              </div>
            </div>
            <div
              v-if="item.fileStatus === 'uploading'"
              class="custom-progress-box"
              :style="`width:${item.rate}%`" />
            <div
              v-if="item.fileStatus === 'waiting'"
              class="waiting-box">
              等待上传
            </div>
          </div>
        </div>
      </el-form>
    </div>
    <div class="dialog-footer">
      <el-button
        size="small"
        class="normal-ang-btn gr8 hollowOut-btn"
        @click="closePanel">
        取消
      </el-button>
      <el-button
        size="small"
        class="primary-btn primary-ang-btn"
        @click="submit">
        确定
      </el-button>
    </div>
  </DragPanel>
</template>

<script>
import DragPanel from '@/components/CustomDragPanel.vue'

import AttachmentUploader from '@/utils/attachmentUploader'
import { Store } from '@/utils/store'
import {
  getBase64,
  compressImgBySize,
  formatFileSize,
  getToken,
  getTokenId
} from '@/utils/generalMethods'

import {
  createSceneAnchorService,
  updateSceneAnchorService,
  getSceneAnchorGroupListService,
  getAnchorTypeListService,
  getAnchorIconListService,
  deleteAnchorIconService,
  getAnchorAttachmentListService,
  deleteAnchorAttachmentService
} from '@/service/interface'

// prettier-ignore
const animAnchorPicPath = "https://demo.bjblackhole.com/css/img/anc_anim - 副本.png";

export default {
  data() {
    return {
      isVisible: false,
      anchorForm: {
        name: '',
        anchorPointDisplayForm: 0,
        groupId: '',
        anchorPointTypeId: undefined,
        useSystemIcon: true,
        iconId: undefined,
        base64Image: '',
        description: '',
        visibleDistance: 1,
        visibleDistanceUnit: 'Kilometer',
        scalingThreshold: 1,
        scalingThresholdUnit: 'Kilometer'
      },
      groupList: [],
      anchorTypeList: [],
      currAnchorIcon: '',
      currAnchorName: '',
      systemIconList: [],
      customIconAction: '',
      isDelIconEnable: false,
      headers: {
        Authorization: getToken()
      },
      uploadParams: {
        FileSize: '',
        FileName: '',
        ProjectZoneId: ''
      },
      customIconList: [],
      attachmentList: [],

      currAnchorId: null,
      currAnchorCamPos: null,
      anchorIcon: true,
      rules: {
        name: [
          {
            required: true,
            message: '请输入批注名称',
            trigger: 'blur'
          }
        ],
        anchorPointDisplayForm: [
          {
            required: true,
            message: '请选择锚点显示形式',
            trigger: 'blur'
          }
        ],
        groupId: [
          {
            required: true,
            message: '请选择所属组',
            trigger: 'blur'
          }
        ],
        anchorPointTypeId: [
          {
            required: true,
            message: '请选择锚点类型',
            trigger: 'blur'
          }
        ],
        anchorIcon: [
          {
            required: true,
            message: '请选择锚点图标',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  props: {
    anchorInfo: Object,
    refreshAnchorList: Function
  },
  components: {
    DragPanel
  },
  created() {
    let uploaders = Store.uploaders
    let find = uploaders.find(el => el.schemeType === 'Anchor')
    if (find) {
      this.customUploader = find.uploader
    } else {
      // prettier-ignore
      this.customUploader = new AttachmentUploader("Anchor", this.checkFilesCount, this.isSameFileCheck);
    }
    this.customIconAction = `${window.serverUrl}/${this.$logServeCof()}/project/scene/v3/anchorPoint/TypeIcon/upload`
  },
  mounted() {
    // prettier-ignore
    this.customUploader.on("attachmentStartUploadFile", this.updateAttachmentList);
    // prettier-ignore
    this.customUploader.on("attachmentUploadSuccess", this.updateAttachmentList);
    this.customUploader.on('updateAttachmentList', this.updateAttachmentList)
    document.addEventListener('RESystemSelElement', this.onSelElement)
    document.addEventListener('RESystemSelShpElement', this.onSelElement)

    this.addEngineCanvasEventListener()

    this.initData()
  },
  beforeDestroy() {
    // prettier-ignore
    this.customUploader.off("attachmentStartUploadFile", this.updateAttachmentList);
    // prettier-ignore
    this.customUploader.off("attachmentUploadSuccess", this.updateAttachmentList);
    this.customUploader.off('updateAttachmentList', this.updateAttachmentList)
    document.removeEventListener('RESystemSelElement', this.onSelElement)
    document.removeEventListener('RESystemSelShpElement', this.onSelElement)

    this.removeEngineCanvasEventListener()
  },
  methods: {
    initData() {
      let anchorInfo = this.anchorInfo
      let groupId = anchorInfo ? anchorInfo.groupId : ''
      this.initGroupList(groupId).then(() => {
        this.initAnchorTypeList().then(() => {
          let useSystemIcon = anchorInfo ? anchorInfo.useSystemIcon : true
          this.initAnchorIconList(useSystemIcon).then(() => {
            if (anchorInfo) {
              this.anchorForm = {
                name: anchorInfo.name,
                anchorPointDisplayForm: anchorInfo.displayForm,
                groupId: groupId,
                anchorPointTypeId: anchorInfo.anchorPointTypeId,
                useSystemIcon: anchorInfo.useSystemIcon,
                iconId: undefined,
                base64Image: '',
                description: anchorInfo.description,
                visibleDistance: anchorInfo.visibleDistance,
                visibleDistanceUnit: anchorInfo.visibleDistanceUnit,
                scalingThreshold: anchorInfo.scalingThreshold,
                scalingThresholdUnit: anchorInfo.scalingThresholdUnit
              }
              this.currAnchorIcon = this.getCurrAnchorIcon(anchorInfo)
              this.currAnchorName = this.getCurrAnchorIconName(anchorInfo)
              this.currAnchorId = anchorInfo.sceneAnchorPointId
              this.currAnchorCamPos = JSON.parse(anchorInfo.visualAngle)

              let attachmentList = anchorInfo.attachmentList.map(item => {
                item.id = item.attachmentId
                item.fileName = item.attachmentName
                // 前端自定义状态，用于效果展示(waiting:等待上传, uploading:正在上传, uploadSuccess:上传成功 )
                item.fileStatus = 'uploadSuccess'
                item.rate = 100
                return item
              })
              this.attachmentList = attachmentList
              this.isVisible = true
            } else {
              this.anchorForm.iconId = this.systemIconList[0].iconId

              this.currAnchorIcon = this.getCurrAnchorIcon()
              this.currAnchorName = this.getCurrAnchorIconName()
            }

            this.$nextTick(() => {
              this.initUploadBtn()
            })
          })
        })
      })
    },
    initGroupList(groupId) {
      return new Promise(resolve => {
        let sceneId = this.$route.query.sceneId
        getSceneAnchorGroupListService(sceneId).then(response => {
          if (response.isSuccess) {
            let groupList = response.data
            this.groupList = groupList
            if (groupId) {
              this.anchorForm.groupId = groupId
            } else {
              this.anchorForm.groupId = this.groupList[0].groupId
            }
            resolve()
          } else {
            this.$message.error(response.errMsg)
          }
        })
      })
    },
    initAnchorTypeList(anchorPointTypeId) {
      return new Promise(resolve => {
        let projectZoneId = this.$route.params.projId
        getAnchorTypeListService({ projectZoneId }).then(response => {
          if (response.isSuccess) {
            let data = response.data
            let anchorTypeList = data.map(item => {
              item.typeName = item.name
              item.typeId = item.anchorPointTypeId
              return item
            })
            this.anchorTypeList = anchorTypeList
            if (anchorPointTypeId) {
              this.anchorForm.anchorPointTypeId = anchorPointTypeId
            } else {
              if (!this.anchorForm.anchorPointTypeId) {
                // prettier-ignore
                this.anchorForm.anchorPointTypeId = this.anchorTypeList[0]?.typeId
              }
            }

            resolve()
          } else {
            this.$message.error(response.errMsg)
          }
        })
      })
    },
    initAnchorIconList(useSystemIcon) {
      return new Promise(resolve => {
        let params = { isSystemIcon: useSystemIcon }
        if (!useSystemIcon) {
          let projId = this.$route.params.projId
          params.projectZoneId = projId
        }
        this.queryAnchorIconList(params).then(iconList => {
          if (useSystemIcon) {
            this.systemIconList = iconList
          } else {
            this.customIconList = iconList
          }
          resolve()
        })
      })
    },
    initUploadBtn() {
      let uploadDom = document.getElementById('anchor-attachment-upload')
      if (uploadDom) {
        let child = uploadDom.children[0]
        if (!child.className.includes('webuploader-pick')) {
          this.customUploader.uploader.addButton({
            id: '#anchor-attachment-upload'
          })
        }
      }
    },
    handleDispalyFormChange(value) {
      if (value === 0) {
        this.anchorForm.useSystemIcon = true
        this.handleUseSystemIconChange(true)
      } else {
        this.updateCurrAnchor()
      }
    },
    openAddAnchorGroupDialog() {
      this.$emit('openAnchorGroupDialog')
    },
    openAddAnchorTypeDialog() {
      this.$emit('openAnchorTypeDialog')
    },
    handleUseSystemIconChange(useSystemIcon) {
      let projId = this.$route.params.projId
      let params = { isSystemIcon: useSystemIcon }
      if (!useSystemIcon) {
        params.projectZoneId = projId
      }
      this.queryAnchorIconList(params).then(iconList => {
        if (iconList.length) {
          this.anchorForm.iconId = iconList[0].iconId
        } else {
          this.anchorForm.iconId = ''
        }

        if (!useSystemIcon) {
          this.customIconList = iconList
        } else {
          this.systemIconList = iconList
        }
        this.currAnchorIcon = this.getCurrAnchorIcon()
        this.currAnchorName = this.getCurrAnchorIconName()

        if (!useSystemIcon && !this.customIconList.length) {
          this.$message.warning('请先上传自定义图标')
        } else {
          this.updateCurrAnchor()
        }
      })
    },
    handleIconClick(iconInfo) {
      let iconId = iconInfo.iconId
      this.anchorForm.iconId = iconId

      this.currAnchorIcon = this.getCurrAnchorIcon()
      this.currAnchorName = this.getCurrAnchorIconName()

      this.updateCurrAnchor()
    },
    enableDeleteIcon() {
      this.isDelIconEnable = true
    },
    handleVisibleChange(visible) {
      this.anchorIcon = !this.anchorIcon
      if (!visible) {
        this.isDelIconEnable = false
      }
    },
    handleCustomIconBeforeUpload(fileInfo) {
      if (this.customIconList.length === 10) {
        let warningMsg = '仅保留最新10个图标，上传新图标将替换最早上传的图标。'
        this.$message.warning(warningMsg)
      }

      const maxFileSize = 2 * 1024 * 1024
      if (fileInfo.size > maxFileSize) {
        this.$message.warning('图标文件超过2M，请重新选择')
        return
      }
    },
    handleCustomIconChange(fileInfo) {
      const compressSize = 500 * 1024

      let projId = this.$route.params.projId
      let fileSize = fileInfo.size
      if (fileSize < compressSize) {
        this.$set(this.uploadParams, 'FileName', fileInfo.name)
        this.$set(this.uploadParams, 'FileSize', fileSize)
        this.$set(this.uploadParams, 'ProjectZoneId', projId)
        this.$set(this.uploadParams, 'FileInfo', fileInfo.raw)
        this.$refs.upload.submit()
      } else {
        getBase64(fileInfo.raw).then(response => {
          compressImgBySize(response, 500).then(res => {
            let fileOfBlob = new File([res], fileInfo.name)
            this.$set(this.uploadParams, 'FileName', fileInfo.name)
            this.$set(this.uploadParams, 'FileSize', fileOfBlob.size)
            this.$set(this.uploadParams, 'ProjectZoneId', projId)
            this.$set(this.uploadParams, 'FileInfo', fileOfBlob)
            this.$refs.upload.submit()
          })
        })
      }
    },
    handleCustomIconSuccess(response) {
      // 图片上传成功
      if (response.isSuccess) {
        let projId = this.$route.params.projId
        let params = { isSystemIcon: false, projectZoneId: projId }
        this.queryAnchorIconList(params).then(iconList => {
          this.customIconList = iconList
          this.isDelIconEnable = false
          this.$refs.upload.clearFiles()
        })
      } else {
        this.$message.error(response.errMsg)
      }
    },
    onCustomIconError() {
      this.$message.error('图片上传失败')
      this.$refs.upload.clearFiles()
    },
    deleteCustomIcon(iconInfo) {
      let iconId = iconInfo.iconId
      deleteAnchorIconService(iconId).then(response => {
        if (response.isSuccess) {
          let projId = this.$route.params.projId
          let params = {
            isSystemIcon: this.anchorForm.useSystemIcon,
            projectZoneId: projId
          }
          this.queryAnchorIconList(params).then(iconList => {
            this.customIconList = iconList
            this.isDelIconEnable = false
          })
        } else {
          this.$message.error(response.errMsg)
        }
      })
    },
    submit() {
      let isExistUploadingFiles = this.attachmentList.some(
        item => item.status === 'uploading'
      )
      if (isExistUploadingFiles) {
        this.$message.warning('附件正在上传中，请稍后再试')
        return
      }

      let anchorPointDisplayForm = this.anchorForm.anchorPointDisplayForm
      let params = {
        name: this.anchorForm.name,
        anchorPointDisplayForm: this.anchorForm.anchorPointDisplayForm,
        groupId: this.anchorForm.groupId,
        anchorPointTypeId: this.anchorForm.anchorPointTypeId,
        // prettier-ignore
        iconId: anchorPointDisplayForm === 0 ? this.anchorForm.iconId : undefined,
        description: this.anchorForm.description,
        visibleDistance: this.anchorForm.visibleDistance,
        visibleDistanceUnit: this.anchorForm.visibleDistanceUnit,
        scalingThreshold: this.anchorForm.scalingThreshold,
        scalingThresholdUnit: this.anchorForm.scalingThresholdUnit,

        visualAngle: this.getViewAngle(),
        position: this.getCurrAnchorPos()
      }

      this.createViewportImg().then(imgSrc => {
        let base64Image = imgSrc.replace('data:image/png;base64,', '')
        params.base64Image = base64Image
        if (this.anchorInfo) {
          let attachments = this.attachmentList.map(item => {
            let obj = {
              attachmentId: item.attachmentId,
              fileDataId: item.fileDataId
            }

            return obj
          })
          params.sceneAnchorPointId = this.anchorInfo.sceneAnchorPointId
          params.attachments = attachments
          updateSceneAnchorService(params).then(response => {
            if (response.isSuccess) {
              this.refreshAnchorList().then(() => {
                this.$message.success('修改锚点成功')
                this.isVisible = false
                this.$emit('closeDialog')
              })
            } else {
              this.$message.error(response.errMsg)
            }
          })
        } else {
          let fileDataIds = this.attachmentList.map(item => {
            return item.fileDataId
          })
          let sceneId = this.$route.query.sceneId
          params.sceneId = sceneId
          params.fileDataIds = fileDataIds
          createSceneAnchorService(params).then(response => {
            if (response.isSuccess) {
              this.refreshAnchorList().then(() => {
                let anchorId = response.data
                this.updateCurrAnchor(anchorId)
                this.$message.success('新增锚点成功')
                this.isVisible = false
                this.$emit('closeDialog')
              })
            } else {
              this.$message.error(response.errMsg)
            }
          })
        }
      })
    },
    closePanel() {
      this.$confirm('放弃编辑将会丢失未保存的数据，确定继续吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        if (!this.anchorInfo) {
          this.deleteAnchor()
        } else {
          this.resetCurrAnchor()
        }

        this.isVisible = false
        this.$emit('closeDialog')
      })
    },
    getCurrAnchorPos() {
      const BlackHole3D = window.BlackHole3D
      let anchorInfo = BlackHole3D.Anchor.getAnc(this.currAnchorId)
      let position = JSON.stringify(anchorInfo.pos)
      return position
    },
    getViewAngle() {
      let camLocate = window.BlackHole3D.Camera.getCamLocate()
      let { camDir, camPos, camRotate } = camLocate
      camDir = camDir.map(el => Number(el.toFixed(6)))
      camPos = camPos.map(el => Number(el.toFixed(6)))
      camRotate = camRotate.map(el => Number(el.toFixed(6)))
      let visualAngleObj = { camDir, camPos, camRotate }
      let visualAngle = JSON.stringify(visualAngleObj)

      return visualAngle
    },
    onSelElement(eventInfo) {
      const BlackHole3D = window.BlackHole3D

      // 清空选择集，防止添加锚点是构件高亮
      BlackHole3D.BIM.delAllSelElems()

      let currProbeRet = BlackHole3D.Probe.getCurCombProbeRet()
      let { elemType } = currProbeRet
      if (!elemType) return

      let camLoc = BlackHole3D.Camera.getCamLocate()
      let camPos = camLoc.camPos
      let camHeight = camPos[2]
      if (camHeight > 100000) {
        // prettier-ignore
        this.$message.warning("当前相机高度超过100公里，无法添加锚点。请降低相机高度后重试。");
        return
      } else {
        this.currAnchorCamPos = camLoc
      }

      let timer = setInterval(() => {
        if (this.currAnchorIcon) {
          let picPath = this.currAnchorIcon
          BlackHole3D.BIM.delAllSelElems()
          if (this.currAnchorId) {
            BlackHole3D.Anchor.delAnc([this.currAnchorId])
          }

          // prettier-ignore
          let anchorId = this.currAnchorId ? this.currAnchorId : `anchor_${new Date().getTime()}`;
          this.currAnchorId = anchorId
          let anchorPos = currProbeRet.elemPos
          let anchorType = this.anchorForm.anchorPointDisplayForm
          let groupId = this.anchorForm.groupId
          let anchorName = this.anchorForm.name
          let visibleDistance = this.anchorForm.visibleDistance
          let visibleDistanceUnit = this.anchorForm.visibleDistanceUnit
          let scalingThreshold = this.anchorForm.scalingThreshold
          let scalingThresholdUnit = this.anchorForm.scalingThresholdUnit
          // prettier-ignore
          let selfAutoScaleDist = scalingThresholdUnit === "Kilometer" ? scalingThreshold * 1000 : scalingThreshold;
          // prettier-ignore
          let selfVisDist = visibleDistanceUnit === "Kilometer" ? visibleDistance * 1000 : visibleDistance;

          let anchorInfo = {
            groupId,
            anchorId,
            anchorName,
            anchorType,
            anchorPos,
            picPath,
            selfAutoScaleDist,
            selfVisDist
          }
          this.addAnchor(anchorInfo)
          this.isVisible = true

          clearInterval(timer)
        }
      }, 500)
    },
    updateCurrAnchor(currAnchorId) {
      const BlackHole3D = window.BlackHole3D

      let anchor = BlackHole3D.Anchor.getAnc(this.currAnchorId)
      if (!anchor) return
      BlackHole3D.Anchor.delAnc([this.currAnchorId])

      if (typeof currAnchorId !== 'string') {
        currAnchorId = ''
      }

      // prettier-ignore
      let anchorId = currAnchorId ? currAnchorId : this.currAnchorId;
      this.currAnchorId = anchorId
      let anchorPos = anchor.pos
      let picPath = this.currAnchorIcon
      let anchorType = this.anchorForm.anchorPointDisplayForm
      let groupId = this.anchorForm.groupId
      let anchorName = this.anchorForm.name
      let visibleDistance = this.anchorForm.visibleDistance
      let visibleDistanceUnit = this.anchorForm.visibleDistanceUnit
      let scalingThreshold = this.anchorForm.scalingThreshold
      let scalingThresholdUnit = this.anchorForm.scalingThresholdUnit
      // prettier-ignore
      let selfAutoScaleDist = scalingThresholdUnit === "Kilometer" ? scalingThreshold * 1000 : scalingThreshold;
      // prettier-ignore
      let selfVisDist = visibleDistanceUnit === "Kilometer" ? visibleDistance * 1000 : visibleDistance;

      let anchorInfo = {
        groupId,
        anchorId,
        anchorName,
        anchorType,
        anchorPos,
        picPath,
        selfAutoScaleDist,
        selfVisDist
      }
      this.addAnchor(anchorInfo)
    },
    resetCurrAnchor() {
      const BlackHole3D = window.BlackHole3D

      let anchor = BlackHole3D.Anchor.getAnc(this.currAnchorId)
      if (!anchor) return

      BlackHole3D.Anchor.delAnc([this.currAnchorId])

      // prettier-ignore
      let anchorId = this.currAnchorId;
      let anchorPos = JSON.parse(this.anchorInfo.position)
      let anchorType = this.anchorInfo.displayForm
      let groupId = this.anchorInfo.groupId
      let anchorName = this.anchorInfo.name
      let visibleDistance = this.anchorInfo.visibleDistance
      let visibleDistanceUnit = this.anchorInfo.visibleDistanceUnit
      let scalingThreshold = this.anchorInfo.scalingThreshold
      let scalingThresholdUnit = this.anchorInfo.scalingThresholdUnit
      // prettier-ignore
      let selfAutoScaleDist = scalingThresholdUnit === "Kilometer" ? scalingThreshold * 1000 : scalingThreshold;
      // prettier-ignore
      let selfVisDist = visibleDistanceUnit === "Kilometer" ? visibleDistance * 1000 : visibleDistance;
      this.currAnchorIcon = this.getCurrAnchorIcon(this.anchorInfo)

      let anchorInfo = {
        groupId,
        anchorId,
        anchorName,
        anchorType,
        anchorPos,
        picPath: this.currAnchorIcon,
        selfAutoScaleDist,
        selfVisDist
      }
      this.addAnchor(anchorInfo)
    },
    addAnchor(anchorInfo) {
      const BlackHole3D = window.BlackHole3D
      let newAnchorInfo = {
        groupName: anchorInfo.groupId,
        ancName: anchorInfo.anchorId,
        pos: anchorInfo.anchorPos,
        textInfo: anchorInfo.anchorName,
        selfAutoScaleDist: anchorInfo.selfAutoScaleDist,
        selfVisDist: anchorInfo.selfVisDist,
        picWidth: 32,
        picHeight: 32,
        texBias: [0, 1],
        texFocus: [16, 0],
        textClr: new BlackHole3D.REColor(255, 255, 255, 255)
      }

      if (anchorInfo.anchorType === 0) {
        newAnchorInfo.ancSize = 32
        newAnchorInfo.picPath = anchorInfo.picPath
      } else {
        newAnchorInfo.picPath = animAnchorPicPath
        newAnchorInfo.picNum = 6
        newAnchorInfo.playFrame = 2
      }

      let anchorList = [newAnchorInfo]
      if (newAnchorInfo.anchorType === 0) {
        window.BlackHole3D.Anchor.addAnc(anchorList)
      } else {
        window.BlackHole3D.Anchor.addAnimAnc(anchorList)
      }
    },
    deleteAnchor() {
      const BlackHole3D = window.BlackHole3D
      let anchor = BlackHole3D.Anchor.getAnc(this.currAnchorId)
      if (anchor) {
        BlackHole3D.Anchor.delAnc([this.currAnchorId])
      }
    },
    addEngineCanvasEventListener() {
      let domRef = window.BlackHole3D.canvas
      domRef.addEventListener('mousemove', this.onCanvasMouseMove)
      domRef.addEventListener('mouseleave', this.onCanvasMouseLeave)
    },
    removeEngineCanvasEventListener() {
      let coorInfo = { visible: false }
      this.$eventManage.fire('canvasMouseMove', { coorInfo })

      let domRef = window.BlackHole3D.canvas
      domRef.removeEventListener('mousemove', this.onCanvasMouseMove)
      domRef.removeEventListener('mouseleave', this.onCanvasMouseLeave)
    },
    onCanvasMouseMove(event) {
      let tipContent = '请点击场景对象以添加锚点'

      if (this.currAnchorId) {
        tipContent = '点击场景对象以更改锚点位置'
      }

      let coorInfo = {
        visible: true,
        tipContent,
        clientX: event.offsetX,
        clientY: event.offsetY
      }
      this.$eventManage.fire('canvasMouseMove', { coorInfo })
    },
    onCanvasMouseLeave() {
      let coorInfo = { visible: false }
      this.$eventManage.fire('canvasMouseMove', { coorInfo })
    },
    queryAnchorIconList(params) {
      return new Promise(resolve => {
        getAnchorIconListService(params).then(response => {
          if (response.isSuccess) {
            let data = response.data
            let iconList = data.map(item => {
              let timestamp = new Date().getTime()
              let imgSrc = `${window.imageBaseUrl}/${item.iconUrl}?timestamp=${timestamp}`
              item.imgSrc = imgSrc
              return item
            })
            resolve(iconList)
          } else {
            this.$message.error(response.errMsg)
          }
        })
      })
    },
    getCurrAnchorIcon(anchorInfo) {
      let imgSrc = ''
      if (anchorInfo) {
        let timestamp = new Date().getTime()
        imgSrc = `${window.imageBaseUrl}/${anchorInfo.iconUrl}?timestamp=${timestamp}`
        return imgSrc
      }

      let useSystemIcon = this.anchorForm.useSystemIcon
      let iconId = this.anchorForm.iconId
      if (!iconId) return undefined

      if (useSystemIcon) {
        let find = this.systemIconList.find(el => el.iconId === iconId)
        imgSrc = find ? find.imgSrc : ''
      } else {
        let find = this.customIconList.find(el => el.iconId === iconId)
        imgSrc = find ? find.imgSrc : ''
      }
      return imgSrc
    },
    getCurrAnchorIconName(anchorInfo) {
      let imgName = ''
      if (anchorInfo) {
        imgName = this.anchorInfo.iconName
        return imgName
      }

      let useSystemIcon = this.anchorForm.useSystemIcon
      let iconId = this.anchorForm.iconId
      if (!iconId) return undefined

      if (useSystemIcon) {
        let find = this.systemIconList.find(el => el.iconId === iconId)
        imgName = find.iconName
      } else {
        let find = this.customIconList.find(el => el.iconId === iconId)
        imgName = find.iconName
      }
      return imgName
    },
    uploadAttachment() {
      this.customUploader.setStatus('waiting')
    },
    viewAttachment(attachmentInfo) {
      let fileDataId = attachmentInfo.fileDataId
      let tokenId = getTokenId()
      let attachmentUrl = `${window.serverUrl}/${window.downloadUrl}/${fileDataId}?token=${tokenId}`

      const fileTypeMap = [
        {
          typeValue: 'text',
          subTypes: ['txt']
        },
        {
          typeValue: 'document',
          subTypes: ['docx']
        },
        {
          typeValue: 'excel',
          subTypes: ['xls', 'xlsx']
        },
        {
          typeValue: 'pdf',
          subTypes: ['pdf']
        }
      ]
      let fileName = attachmentInfo.fileName
      let fileType = fileName.substring(fileName.lastIndexOf('.') + 1)
      fileType = fileType.toLowerCase()
      let find = fileTypeMap.find(item => item.subTypes.includes(fileType))
      let attachmentType = find.typeValue

      const routerUrl = this.$router.resolve({
        path: `../../../attachmentView`,
        query: { attachmentType, attachmentUrl }
      })

      window.open(routerUrl.href, '_blank')
    },
    downloadAttachment(attachmentInfo) {
      let url = ''
      let fileDataId = attachmentInfo.fileDataId
      let tokenId = getTokenId()
      if (window.downloadUrl.includes('http')) {
        url = `${window.downloadUrl}/${fileDataId}?token=${tokenId}`
      } else {
        url = `${window.serverUrl}/${window.downloadUrl}/${fileDataId}?token=${tokenId}`
      }

      this.downloadURL(url, 1)
    },
    downloadURL(url, id) {
      let hiddenIFrameID = 'hiddenDownloader' + id
      let iframe = document.createElement('iframe')
      iframe.id = hiddenIFrameID
      iframe.style.display = 'none'
      document.body.appendChild(iframe)
      iframe.src = url
    },
    deleteAttachment(attachment) {
      let findIndex = this.attachmentList.findIndex(
        item => item.id === attachment.id
      )
      this.attachmentList.splice(findIndex, 1)

      let attachmentId = attachment.attachmentId
      if (attachmentId) {
        deleteAnchorAttachmentService(attachmentId).then(response => {
          if (response.isSuccess) {
            this.$message.success('删除成功')
          } else {
            this.$message.error(response.errMsg)
          }
        })
      }
    },
    updateAttachmentList() {
      this.queryAttachmentList().then(attachmentList => {
        // 前端的上传文件列表
        let customUploadList = []
        let uploadFiles = this.customUploader.uploadFiles
        let uploadingFiles = this.customUploader.uploadingFiles
        uploadingFiles.forEach(item => (item.fileStatus = 'uploading'))
        uploadFiles.forEach(item => (item.fileStatus = 'waiting'))

        customUploadList = [
          ...uploadingFiles,
          ...uploadFiles,
          ...attachmentList
        ]

        customUploadList.forEach(item => {
          let find = this.attachmentList.find(el => el.id === item.id)
          if (find) {
            this.$set(find, 'rate', find.rate)
          } else {
            this.attachmentList.push(item)
          }
        })

        this.attachmentList.forEach(item => {
          if (item.rate === 100) {
            item.fileStatus = 'uploadSuccess'
          }
        })
      })
    },
    queryAttachmentList() {
      return new Promise(resolve => {
        let attachmentList = []
        let anchorInfo = this.anchorInfo
        if (anchorInfo) {
          let anchorPointId = anchorInfo.sceneAnchorPointId
          getAnchorAttachmentListService(anchorPointId).then(response => {
            if (response.isSuccess) {
              let data = response.data
              attachmentList = data.map(item => {
                item.id = item.attachmentId
                item.fileName = item.attachmentName
                // 前端自定义状态，用于效果展示(waiting:等待上传, uploading:正在上传, uploadSuccess:上传成功 )
                item.fileStatus = 'uploadSuccess'
                item.rate = 100
                return item
              })
              resolve(attachmentList)
            } else {
              this.$message.error(response.message)
            }
          })
        } else {
          resolve(attachmentList)
        }
      })
    },
    checkFilesCount(fileList) {
      return new Promise(resolve => {
        let attachmentList = [...fileList, ...this.attachmentList]
        if (attachmentList.length > 5) {
          let message = '超出文件数量限制，最多只能上传5个附件，请重新选择文件'
          this.$message.warning(message)
          resolve(false)
        } else {
          resolve(true)
        }
      })
    },
    isSameFileCheck(fileInfo) {
      let isCheckPass = true

      let find = this.attachmentList.find(item => {
        // prettier-ignore
        let isSameFileFlag = (item.fileName === fileInfo.fileName && item.fileName.length === fileInfo.fileName.length)
        return isSameFileFlag
      })

      if (find) {
        isCheckPass = false
      }

      return isCheckPass
    },
    getFileTypeIcon(fileName) {
      let fileType = fileName.substring(fileName.lastIndexOf('.') + 1)
      fileType = fileType.toLowerCase()

      let imgSrc = ''
      switch (fileType) {
        case 'doc':
          imgSrc = require('@/assets/icon/doc.png')
          break
        case 'docx':
          imgSrc = require('@/assets/icon/doc.png')
          break
        case 'xls':
          imgSrc = require('@/assets/icon/xls.png')
          break
        case 'xlsx':
          imgSrc = require('@/assets/icon/xls.png')
          break
        case 'pdf':
          imgSrc = require('@/assets/icon/pdf.png')
          break
        case 'txt':
          imgSrc = require('@/assets/icon/txt.png')
          break
        case 'zip':
          imgSrc = require('@/assets/icon/zip.png')
          break
        default:
          imgSrc = require('@/assets/icon/png.png')
          break
      }

      return imgSrc
    },
    getAttachmentNameClassName(attachmentInfo) {
      let className = 'name-box text-overflow'
      if (attachmentInfo.fileStatus === 'waiting') {
        className += ' waiting-color'
      } else {
        className += ' normal-color'
      }
      return className
    },
    getFileSize(fileSize) {
      let size = formatFileSize(fileSize).fileSize
      let unit = formatFileSize(fileSize).unit
      let fileSizeStr = `${size}${unit}`
      return fileSizeStr
    },
    isViewAttachmentBtnVisible(attachmentInfo) {
      let fileName = attachmentInfo.fileName
      let fileType = fileName.substring(fileName.lastIndexOf('.') + 1)
      fileType = fileType.toLowerCase()

      const visibleFileTypes = ['docx', 'xls', 'xlsx', 'pdf', 'txt']
      return visibleFileTypes.includes(fileType)
    },
    async createViewportImg() {
      const BlackHole3D = window.BlackHole3D
      let { camPos, camRotate } = this.currAnchorCamPos
      let camLoc = new BlackHole3D.RECamLoc()
      camLoc.camPos = camPos
      camLoc.camRotate = camRotate

      BlackHole3D.Camera.setCamLocateTo(camLoc, 0, 0)
      BlackHole3D.Graphics.setGeoCoordVisible(false)
      BlackHole3D.Graphics.setViewCubeVisible(false)
      BlackHole3D.Graphics.setSysUIPanelVisible(false)

      await this.sleep(100)

      let imgSrc = BlackHole3D.getScreenSnapshot()
      BlackHole3D.Graphics.setGeoCoordVisible(true)
      BlackHole3D.Graphics.setViewCubeVisible(true)
      BlackHole3D.Graphics.setSysUIPanelVisible(true)

      return imgSrc
    },
    sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms))
    },
    getTitle() {
      let title = this.anchorInfo ? '编辑锚点' : '新建锚点'
      return title
    }
  }
}
</script>

<style lang="less" scoped>
@import '@/assets/css/publishSearch.less';

.common-drag-panel {
  top: 124px;
  left: 380px;
  width: 500px;
  height: unset;

  :deep(.header-box) {
    .title-box {
      .icon-box {
        display: none;
      }
    }
  }

  :deep(.drag-resize) {
    display: none;
  }

  .anchor-form-box {
    padding: 16px;
    :deep(.public-form-primary) {
      .el-form-item {
        margin-bottom: 12px;

        .el-form-item__label {
          padding: 0px;
          line-height: 32px;

          &::before {
            margin-right: 2px;
          }
        }

        .el-form-item__content {
          line-height: 32px;
        }

        .primary-select {
          width: 100%;

          .el-select-dropdown {
            left: 0px !important;
            margin-top: 4px;
          }
        }

        .el-input-number {
          width: 100%;
          line-height: inherit;

          .el-input__inner {
            text-align: left;
          }
        }

        .label-with-tip-box {
          display: flex;
          align-items: center;
          justify-content: flex-end;

          .icon-box {
            margin: 0px 5px;
          }
        }

        .radio-group-box {
          display: flex;
          align-items: center;
          height: 16px;
          margin-top: 10px;
        }

        .grid-item-box {
          display: grid;
          grid-template-columns: 4fr 2fr;

          &.special-grid-item {
            grid-template-columns: 4fr 2fr 5fr;
          }

          .left-item-box {
            padding-right: 8px;
          }
        }

        .symbol-grid-icon-box {
          display: grid;
          grid-template-columns: 3.5fr 7fr;
          line-height: 0;
          margin: 4px 0px;

          .anchor-symbol-icon-box {
            display: flex;
            align-items: center;
            justify-content: space-between;
            background: var(--anchor-add-icon-bgColor);
            padding: 5px 10px;
            border-radius: 8px;
            border: 1px solid var(--anchor-add-icon-border-Color);

            .arrow-icon-box {
              transition: all 0.3s;
            }

            .img-info-box {
              display: flex;
              align-items: center;
              height: 20px;
              line-height: 19px;
              max-width: 180px;
              color: var(--form-input-text-color);

              .img-box {
                flex-shrink: 0;
                width: 20px;
                height: 20px;
                margin-right: 5px;
                background-repeat: no-repeat;
                background-size: 100% 100%;
              }
            }

            .activeArrow {
              transform: rotate(180deg);
              transform-origin: center;
              margin-right: -6px;
              .el-icon-arrow-down {
                color: var(--base-primary-bgColor);
              }
            }
          }

          .activeSelect {
            .anchor-symbol-icon-box {
              border: 1px solid var(--base-primary-bgColor);
              box-shadow: var(--base-bg-light-color35);
            }
          }
          .right-item-box {
            margin-left: 8px;
            .dropdown-primary {
              width: 100%;
              padding: 8px;
              top: 32px !important;
              left: 0px !important;
              margin-top: 4px;

              .el-dropdown-menu__item {
                .primary-btn {
                  font-size: 12px;
                  padding: 5px 11px;
                  color: var(--aside-bg-color);
                }

                i {
                  margin: 0px;
                }
              }

              .system-icon-box {
                display: flex;
                align-items: center;
                padding: 0px;
                background: var(--anchor-add-system-icon-bgColor);

                .img-box {
                  width: 32px;
                  height: 32px;
                  cursor: pointer;

                  img {
                    width: 100%;
                    height: 100%;
                  }
                }
              }

              .custom-icon-box {
                display: block;
                width: 100%;
                height: unset;
                padding: 0px;
                background: var(--anchor-add-custom-icon-bgColor);

                .img-list-box {
                  display: inline-flex;
                  align-items: center;
                  flex-wrap: wrap;
                  gap: 8px;
                  width: 100%;

                  .img-empty-box {
                    color: var(--base-dark19-color);

                    .bold-text-box {
                      font-weight: bold;
                      color: var(--page-tips-text-bold-color);
                    }
                  }

                  .img-item-box {
                    position: relative;
                    display: inline-block;
                    width: 24px;
                    height: 24px;
                    cursor: pointer;
                    padding: 4px;
                    border-radius: 7px;
                    background-position: center;
                    background-repeat: no-repeat;
                    background-size: 80% 80%;

                    .delete-icon-box {
                      position: absolute;
                      top: -5px;
                      right: -5px;
                      width: 12px;
                      height: 12px;
                      font-size: 10px;
                      cursor: pointer;
                      border-radius: 50%;
                      text-align: center;
                      line-height: 12px;
                      background: var(--base-bg-dark-color33);
                    }

                    &.is-delete-enable {
                      background-color: var(--base-bg-dark-color33);

                      &:hover {
                        background-color: var(--base-bg-light-color24);

                        .delete-icon-box {
                          background-color: var(--base-bg-light-color24);
                        }
                      }
                    }

                    &:hover {
                      background-color: var(--base-bg-light-color24);
                    }
                  }

                  .img-action-box {
                    display: flex;
                    align-items: center;
                    margin-left: auto;

                    .el-button {
                      height: unset;
                      padding: 4px 11px;

                      &:focus {
                        color: var(--base-dark18-color);
                        background: transparent;
                      }
                    }

                    .el-upload {
                      margin-left: 8px;
                    }
                  }
                }
              }
            }
          }
        }

        .upload-btn {
          margin-top: 5px;

          .webuploader-pick {
            color: var(--attachment-upload-text-color);

            span {
              &:first-child {
                display: flex;
                align-items: center;

                span {
                  margin-right: 8px;
                }
              }
            }
          }
        }
      }

      .last-form-item {
        margin-bottom: 0px;
      }

      .attachment-file-list-box {
        font-size: 14px;
        margin-left: 80px;

        .file-item-box {
          position: relative;
          margin: 4px 0px;
          border-radius: 8px;

          .file-info-box {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 5px 8px;
            background: var(--attachment-bg-color);
            border-radius: 8px;
            border: 1px solid var(--attachment-border-color);

            .file-name-box {
              display: flex;
              align-items: center;
              text-align: left;
              overflow: hidden;

              .icon-box {
                img {
                  vertical-align: bottom;
                }
              }

              .name-box {
                margin-left: 5px;
              }

              .normal-color {
                color: var(--attachment-normal-color);
              }

              .waiting-color {
                color: var(--attachment-waiting-color);
              }
            }

            .file-action-btn-box {
              flex-shrink: 0;
              width: 80px;
              display: flex;
              align-items: center;
              justify-content: flex-end;

              .el-button--text {
                margin-left: 0px;
                color: var(--attachment-normal-color);
                padding: 2px;

                &:hover {
                  background: var(--base-bg-dark-color33);
                }
              }
            }
          }

          .custom-progress-box {
            position: absolute;
            top: 0px;
            width: 0;
            height: 100%;
            background: var(--base-bg-light-color70);
            z-index: 2;
            border-radius: 8px;
          }

          .waiting-box {
            position: absolute;
            top: 0px;
            width: 100%;
            height: 100%;
            background: rgba(0, 0, 0, 0.1);
            z-index: 2;
            border-radius: 8px;
            text-align: right;
            padding: 0px 8px;
            line-height: 32px;
            color: var(--base-dark21-color);
          }
        }
      }
    }
  }

  .dialog-footer {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    width: 100%;
    padding: 10px 16px;
    text-align: right;
    // border-top: 1px solid var(--base-border-dark-color14);
  }
}
</style>
